import AccordionV2 from "@components/Accordion/AccordionV2";
import { ConstituenciesData } from "@pages/SingaporeGe/2025/utils/types";
import { CommonClassNameAndTestId } from "@typings/Common";
import { cn } from "@util/helpers";

type ConstituenciesToWatchCardProps = {
  constituenciesData: ConstituenciesData;
} & CommonClassNameAndTestId;

export default function ConstituenciesToWatchCard({
  constituenciesData,
  testId = "constituencies-to-watch-card-component",
}: ConstituenciesToWatchCardProps): React.ReactElement {
  const { title, kicker, paragraph, parties } = constituenciesData;
  return (
    <div
      data-testid={testId}
      className="h-full border border-gray-850 p-4 text-gray-850 lg:p-6"
    >
      <p className="font-xl mb-0 font-poppins font-semibold">
        {title} <span className="text-4xs font-normal">{kicker}</span>
      </p>

      <p className="mb-6">{paragraph}</p>

      {parties.map((party, index) => {
        return (
          <AccordionV2
            className={cn("pb-3", {
              "pt-3": index !== 0,
              "border-0": index === parties.length - 1,
            })}
            headerChildren={
              <div className="flex items-center">
                <img
                  width={32}
                  height={32}
                  src={party.partyImage}
                  alt={party.party}
                  className="mr-3"
                />

                <p className="font-poppins text-xs font-semibold">
                  {party.party}
                  {party.incumbent ? (
                    <span className="text-xs font-light"> - INCUMBENT</span>
                  ) : null}
                </p>
              </div>
            }
            arrowClassName="border-0"
            key={party.party}
          >
            <div className="py-3 font-public-sans text-gray-850">
              <p className="mb-3">{party.members.membersName}</p>

              <div className="flex flex-row">
                {party.members.membersImage.map((memberImage, index) => {
                  return (
                    <img
                      key={party.members.membersName}
                      src={memberImage}
                      alt={party.members.membersName}
                      width={40}
                      height={40}
                      className={cn("h-10 w-10 rounded-full", {
                        "-ml-1": index !== 0,
                      })}
                    />
                  );
                })}
              </div>
            </div>
          </AccordionV2>
        );
      })}
    </div>
  );
}
